import React, { useState } from "react";
import { Tilt } from "react-tilt";
import { RightCircleFilled, LeftCircleFilled, UnorderedListOutlined } from "@ant-design/icons";

import bg1 from "../../assests/bgs/bg1.jpg";
import bg2 from "../../assests/bgs/bg2.jpg";
import bg3 from "../../assests/bgs/bg3.jpg";
import bg4 from "../../assests/bgs/bg4.jpg";
import bg5 from "../../assests/bgs/bg5.jpg";
import bg6 from "../../assests/bgs/bg6.jpg";
import bg7 from "../../assests/bgs/bg7.jpg";
import bg8 from "../../assests/bgs/bg8.jpg";
import bg9 from "../../assests/bgs/bg9.jpg";
import bg0 from "../../assests/bgs/bg0.jpg";

const defaultOptions = {
  reverse: false,
  max: 35,
  perspective: 1000,
  scale: 1.05,
  speed: 500,
  transition: true,
  axis: null,
  reset: true,
  easing: "cubic-bezier(.03,.98,.52,.99)",
};

function BookItem({
  card,
  prevIndex,
  nextIndex,
  hasFilters,
  onCloudClick,
  onSeriesClick,
  onLivroClick,
  onMenuClick,
  clearFilters,
  setSeriesFilter,
  setTagFilter,
  selectedTag,
  selectedSeries,
}) {
  const [showDetails, setDetails] = useState(false);

  const showDetailsHandler = () => {
    setDetails(!showDetails);
  };
  //generate a random int between 0 and 9
  const randomInt = Math.floor(Math.random() * 10);
  const matrix = [bg0, bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8, bg9];
  const randomStr = matrix[randomInt];
  return (
    <>
      <div className="card-item-button">
        <div>
          <UnorderedListOutlined style={{ fontSize: "50px", color: "white" }} onClick={onMenuClick} />
        </div>
      </div>
      <Tilt options={defaultOptions} className="card-item flip-card">
        <div className={`flip-card-inner ${showDetails ? "flip-card-active" : ""}`} onClick={showDetailsHandler}>
          <div className="card-item-info flip-card-front space" style={{ backgroundImage: `url(${randomStr})` }}>
            {" "}
            <div className="triangulo2">
              <div
                className="card-item-details-section-zero"
                style={{
                  flex: 1,
                  height: "100%",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignContent: "center",
                  display: "flex",
                }}>
                <div
                  className="card-item-header"
                  style={{
                    flex: 1,
                  }}>
                  <p
                    className="card-item-title"
                    style={{
                      color: "white",
                      textAlign: "center",
                    }}>
                    {card?.product_name}
                  </p>
                </div>
                <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <img className="capaLivro" src={card?.thumbnail} alt="produc error" />
                </div>

                <div
                  className="card-item-body"
                  style={{
                    flex: 1,
                    flexGrow: 1,
                    justifyContent: "flex-end",
                  }}>
                  <p className="card-item-title">
                    {card?.product_name}
                    {card?.isNew ? <span>Novidade</span> : null}
                  </p>
                  <p className="card-item-subtitlef">{card?.author}</p>
                  <div className="card-item-tags">
                    <div className="card-item-tags--list">
                      <div
                        key={"series"}
                        className={`${selectedSeries === card?.serie_name ? "card-item-tags--list--selected" : ""}`}
                        onClick={() => {
                          clearFilters();
                          setSeriesFilter(card?.serie_name);
                        }}>
                        {card?.serie_name}
                      </div>
                      {card?.tags?.map((tag, i) => (
                        <div
                          key={i}
                          className={`${selectedTag === tag ? "card-item-tags--list--selected" : ""}`}
                          onClick={() => {
                            clearFilters();
                            setTagFilter(tag);
                          }}>
                          {tag}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-item-details flip-card-back">
            <div className="card-item-details-section-one">
              <div className="card-item-photo">
                <img src={card?.thumbnail} alt="produc error" />
              </div>
              <p className="card-item-title">{card?.product_name}</p>
              <div className="card-item-details--description">
                <TextWithLineBreaks text={card?.description} />
              </div>
            </div>
          </div>
        </div>
      </Tilt>
      <div className="card-item-button">
        <div>
          <LeftCircleFilled style={{ fontSize: "50px", color: "white" }} onClick={prevIndex} size={50} />
        </div>
        <div className="card-item-button--price">
          {card?.valores?.map((valor, i) => (
            <p key={i}>{valor > 0 && (i === 0 ? "Compacto: R$ " + valor.toFixed(2) : "Clássico: R$ " + valor.toFixed(2))}</p>
          ))}
        </div>

        <div>
          <RightCircleFilled style={{ fontSize: "50px", color: "white" }} onClick={nextIndex} />
        </div>
      </div>
    </>
  );
}

export default BookItem;

function TextWithLineBreaks(props) {
  const text = props.text;
  return (
    <div>
      {text.split('\n').map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < text.split('\n').length - 1 && <br />}
        </React.Fragment>
      ))}
    </div>
  );
}
